module.exports = __webpack_public_path__ + "img/Mikkel.52a7723e.svg";